import styled from 'styled-components/macro';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import moment from 'moment';
import SingleThemeBubble from './SingleThemeBubble';
import DoubleThemeBubble from './DoubleThemeBubble';
import { IThemeInfo } from 'scheme/themeInfo';

interface IImageSliderProps {
  sliderSettings: ISliderSettings;
  openedThemes: IThemeInfo[];
  beforeOpenedThemes: IThemeInfo[];
  now: moment.Moment;
  handleBeforeOpenedClick: () => void;
}

interface ISliderSettings {
  dots: boolean;
  dotsClass: string;
  infinite: boolean;
  speed: number;
  slidesToShow: number;
  slidesToScroll: number;
  arrows: boolean;
  centerMode: boolean;
}

export default function ImageSlider({
  sliderSettings,
  openedThemes,
  beforeOpenedThemes,
  now,
  handleBeforeOpenedClick,
}: IImageSliderProps) {
  return (
    <>
      <ImageSliderContainer>
        <StyledSlider {...sliderSettings}>
          {openedThemes.map((themeInfo) =>
            themeInfo.themes.length > 1 ? (
              <>
                <DoubleThemeBubble
                  isOpen={now.diff(themeInfo.date, 'milliseconds') > 0}
                  themeInfo={themeInfo}
                  handleBeforeOpenedClick={handleBeforeOpenedClick}
                />
              </>
            ) : (
              <>
                <SingleThemeBubble
                  isOpen={now.diff(themeInfo.date, 'milliseconds') > 0}
                  themeInfo={themeInfo}
                  handleBeforeOpenedClick={handleBeforeOpenedClick}
                />
              </>
            ),
          )}
          {beforeOpenedThemes.map((themeInfo) =>
            themeInfo.themes.length > 1 ? (
              <>
                <DoubleThemeBubble
                  isOpen={now.diff(themeInfo.date, 'milliseconds') > 0}
                  themeInfo={themeInfo}
                  handleBeforeOpenedClick={handleBeforeOpenedClick}
                />
              </>
            ) : (
              <>
                <SingleThemeBubble
                  isOpen={now.diff(themeInfo.date, 'milliseconds') > 0}
                  themeInfo={themeInfo}
                  handleBeforeOpenedClick={handleBeforeOpenedClick}
                />
              </>
            ),
          )}
        </StyledSlider>
      </ImageSliderContainer>
    </>
  );
}

const ImageSliderContainer = styled.div`
  margin-top: 3.2rem;
`;

const StyledSlider = styled(Slider)`
  margin-bottom: 30px;
  width: 100%;
  .slick-slide div {
    outline: none;
  }

  .slick-track div {
  }
`;
